import React from "react";
import InputCheckbox from "../../components/InputCheckbox";
import InputNumberOnly from "../../components/InputNumberOnly";
import { Upload, message, Button, Row, Col, Typography } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  setItem,
  removeItem,
  getItem,
  getPaymentUser,
  getPaymentGroup,
  formatAmount,
  labelsPerFrequency,
} from "utils";
import checkCircle from "../../assets/img/check-circle.png";
import checkCircleDefault from "../../assets/img/check-circle-default.png";
import { useDraggable } from "react-use-draggable-scroll";
import { useParams } from "react-router-dom";
import { Radio } from "antd";

import { AiOutlineCheck } from "react-icons/ai";
import { FaAward } from "react-icons/fa";


export default function BenefitItem({ text, leftAdornment, check, highlighted, special }) {
    return (
      <div
        className="__signup-benefit-item-container"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <AiOutlineCheck
            style={{
              ...(highlighted && { color: "#00C569" }),
              ...(special && { color: "#b48e36" }),
              ...(!highlighted && !special && { color: "#444" }),
              fontSize: "20px",
              width: "20px",
              height: "20px",
            }}
          />
  
          <p
            className="__signup-embed-benefits"
            style={{
              ...(highlighted && { color: "#00C569" }),
              ...(special && { color: "#b48e36" }),
            }}
          >
            {text}
          </p>
        </div>
  
        {leftAdornment && (
          <p
            className="__signup-embed-benefits-adornment"
            style={{ alignSelf: "center" }}
          >
            {leftAdornment}
          </p>
        )}
        {special && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              margin: -5,
              borderRadius: 10,
              padding: 3,
              borderWidth: 2,
              alignSelf: "center",
              border: "2px solid rgb(180, 142, 54)",
            }}
          >
            <p
              style={{
                fontSize: 11,
                fontWeight: "bold",
                textTransform: "uppercase",
                marginLeft: 7,
                marginRight: 5,
                color: "#b48e36",
                marginBottom: "0px",
              }}
            >
              Exclusivo
            </p>
            <FaAward
              style={{
                color: "#b48e36",
                fontSize: "20px",
                width: "20px",
                height: "20px",
              }}
            />
          </div>
        )}
      </div>
    );
  }